import React from 'react'
import { Helmet } from 'react-helmet'
import './privacy-policy.css'

const PrivacyPolicy = (props) => {
    return (
        <div className="privacy-policy-container">
            <Helmet>
                <title>Política de Privacidad - Variant AI</title>
                <meta property="og:title" content="Política de Privacidad - Variant AI" />
            </Helmet>
            <div className="privacy-policy-content">
                <h1>Política de Privacidad y Tratamiento de Datos Personales</h1>
                <p><strong>Fecha de entrada en vigencia:</strong> 05 de Febrero de 2026</p>

                <p>En <strong>Aplicaciones y Desarrollos Inteligentes S.A.S</strong>, nos comprometemos a proteger la privacidad y seguridad de la información personal de nuestros usuarios y clientes. Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos sus datos personales, en cumplimiento con las normativas vigentes y los requisitos de las leyes actuales.</p>

                <h2>1. Información que Recopilamos</h2>
                <p>Para la prestación de nuestros servicios, incluyendo atención al cliente y uso de nuestros agentes de inteligencia artificial, podemos recopilar los siguientes datos personales:</p>
                <ul>
                    <li><strong>Datos de Identificación:</strong> Nombre completo.</li>
                    <li><strong>Datos de Contacto:</strong> Número de teléfono (móvil y WhatsApp), dirección de correo electrónico (email).</li>
                    <li><strong>Datos de Interacción:</strong> Historial de conversaciones, consultas realizadas a través de nuestros canales de soporte o ventas.</li>
                </ul>

                <h2>2. Finalidad del Tratamiento de Datos</h2>
                <p>Los datos recolectados serán utilizados para las siguientes finalidades:</p>
                <ol>
                    <li><strong>Prestación del Servicio:</strong> Gestionar sus solicitudes, responder dudas y proveer el servicio de agentes inteligentes.</li>
                    <li><strong>Atención al Cliente:</strong> Utilizar su número de teléfono para enviar notificaciones importantes, respuestas a consultas y soporte a través de WhatsApp, cumpliendo con las políticas de WhatsApp Business.</li>
                    <li><strong>Mejora del Servicio:</strong> Analizar interacciones para entrenar y mejorar la precisión de nuestros agentes de IA.</li>
                    <li><strong>Comunicaciones:</strong> Enviar información relevante sobre actualizaciones, nuevos servicios o cambios en esta política.</li>
                </ol>

                <h2>3. Uso de la API de WhatsApp</h2>
                <p>Al interactuar con nosotros a través de WhatsApp, usted acepta que su número de teléfono y la información compartida en el chat sean procesados por Aplicaciones y Desarrollos Inteligentes S.A.S y Meta Platforms, Inc. (proveedor de WhatsApp), de acuerdo con sus respectivos términos de servicio y políticas de privacidad.</p>
                <p>No enviaremos mensajes promocionales no solicitados (SPAM) a través de WhatsApp sin su consentimiento previo y explícito (Opt-in).</p>

                <h2>4. Derechos del Titular</h2>
                <p>Como titular de sus datos personales, usted tiene derecho a:</p>
                <ul>
                    <li>Conocer, actualizar y rectificar sus datos personales.</li>
                    <li>Solicitar prueba de la autorización otorgada para el tratamiento de datos.</li>
                    <li>Ser informado sobre el uso que se ha dado a sus datos.</li>
                    <li>Revocar la autorización y/o solicitar la supresión del dato cuando no se respeten los principios, derechos y garantías constitucionales y legales.</li>
                </ul>

                <h2>5. Contacto</h2>
                <p>Para ejercer sus derechos o resolver dudas sobre esta política, puede contactarnos a través de:</p>
                <ul>
                    <li><strong>Correo Electrónico:</strong> service@variant.com.co</li>
                </ul>

                <h2>6. Cambios en la Política</h2>
                <p>Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento. Cualquier cambio será publicado en este sitio web.</p>

                <br />
                <p><em>Aplicaciones y Desarrollos Inteligentes S.A.S - Transformando la comunicación con Inteligencia Artificial.</em></p>
            </div>
        </div>
    )
}

export default PrivacyPolicy
